var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vks-v2g-drawer research-data-table-wrapper" },
    [
      _vm.loadingTissue
        ? _c("div", { staticClass: "vks-ui-status" }, [
            _vm._v(
              " Loading gene links for " + _vm._s(_vm.loadingTissue) + "… "
            ),
          ])
        : _vm.error
        ? _c(
            "div",
            {
              staticClass: "vks-ui-error vks-ui-error--boxed",
              attrs: { role: "alert" },
            },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : _vm._e(),
      _c(
        "section",
        { staticClass: "vks-drawer-section vks-drawer-section--controls" },
        [
          _c(
            "div",
            {
              staticClass: "vks-ui-tabs",
              attrs: {
                role: "tablist",
                "aria-label": "Variant-to-gene controls",
              },
            },
            _vm._l(_vm.controlTabs, function (tab) {
              return _c(
                "button",
                {
                  key: tab.id,
                  staticClass: "vks-ui-tab",
                  class: { "is-active": _vm.activeControlTab === tab.id },
                  attrs: {
                    id: `vks-v2g-tab-${tab.id}`,
                    type: "button",
                    role: "tab",
                    "aria-selected":
                      _vm.activeControlTab === tab.id ? "true" : "false",
                    "aria-controls": `vks-v2g-panel-${tab.id}`,
                  },
                  on: {
                    click: function ($event) {
                      _vm.activeControlTab = tab.id
                    },
                  },
                },
                [_vm._v(" " + _vm._s(tab.label) + " ")]
              )
            }),
            0
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeControlTab === "tissues",
                  expression: "activeControlTab === 'tissues'",
                },
              ],
              staticClass: "vks-ui-tab-panel",
              attrs: {
                id: "vks-v2g-panel-tissues",
                role: "tabpanel",
                "aria-labelledby": "vks-v2g-tab-tissues",
              },
            },
            [
              _vm.geLoading
                ? _c("div", { staticClass: "vks-ui-status" }, [
                    _vm._v(" Loading tissue options… "),
                  ])
                : _vm.tissueOptions.length
                ? [
                    _c(
                      "ul",
                      {
                        staticClass: "vks-v2g-tissue-list",
                        attrs: { role: "group", "aria-label": "Tissues" },
                      },
                      _vm._l(_vm.tissueOptions, function (tissue) {
                        return _c(
                          "li",
                          { key: tissue, staticClass: "vks-v2g-tissue-item" },
                          [
                            _c(
                              "label",
                              { staticClass: "vks-v2g-tissue-check" },
                              [
                                _c("input", {
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: _vm.isTissueSelected(tissue),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onToggleTissue(tissue, $event)
                                    },
                                  },
                                }),
                                _c("span", [_vm._v(_vm._s(tissue))]),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _c("div", { staticClass: "vks-ui-btn-row" }, [
                      _c(
                        "button",
                        {
                          staticClass: "vks-ui-btn vks-ui-btn--secondary",
                          attrs: {
                            type: "button",
                            disabled: !_vm.selectedTissues.length,
                          },
                          on: { click: _vm.clearTissues },
                        },
                        [_vm._v(" Clear tissues ")]
                      ),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeControlTab === "filters",
                  expression: "activeControlTab === 'filters'",
                },
              ],
              staticClass: "vks-ui-tab-panel",
              attrs: {
                id: "vks-v2g-panel-filters",
                role: "tabpanel",
                "aria-labelledby": "vks-v2g-tab-filters",
              },
            },
            [
              _vm.hasTrackData
                ? [
                    _vm.methodOptions.length
                      ? _c("div", { staticClass: "vks-v2g-settings-block" }, [
                          _c("p", { staticClass: "vks-v2g-settings-label" }, [
                            _vm._v("Methods"),
                          ]),
                          _c(
                            "ul",
                            {
                              staticClass: "vks-v2g-filter-list",
                              attrs: { role: "group", "aria-label": "Methods" },
                            },
                            _vm._l(_vm.methodOptions, function (method) {
                              return _c(
                                "li",
                                {
                                  key: method,
                                  staticClass: "vks-v2g-filter-item",
                                },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "vks-v2g-filter-check" },
                                    [
                                      _c("input", {
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: _vm.isMethodSelected(method),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onToggleMethod(
                                              method,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [_vm._v(_vm._s(method))]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm.geneOptions.length
                      ? _c("div", { staticClass: "vks-v2g-settings-block" }, [
                          _c("div", { staticClass: "vks-v2g-settings-head" }, [
                            _c("p", { staticClass: "vks-v2g-settings-label" }, [
                              _vm._v("Genes"),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "vks-ui-btn-row vks-v2g-settings-actions",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "vks-ui-btn vks-ui-btn--secondary",
                                    attrs: { type: "button" },
                                    on: { click: _vm.selectAllGenes },
                                  },
                                  [_vm._v(" Select all ")]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "vks-ui-btn vks-ui-btn--secondary",
                                    attrs: { type: "button" },
                                    on: { click: _vm.unselectAllGenes },
                                  },
                                  [_vm._v(" Unselect all ")]
                                ),
                              ]
                            ),
                          ]),
                          _c(
                            "ul",
                            {
                              staticClass: "vks-v2g-filter-list",
                              attrs: { role: "group", "aria-label": "Genes" },
                            },
                            _vm._l(_vm.geneOptions, function (gene) {
                              return _c(
                                "li",
                                {
                                  key: gene,
                                  staticClass: "vks-v2g-filter-item",
                                },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "vks-v2g-filter-check" },
                                    [
                                      _c("input", {
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: _vm.isGeneSelected(gene),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onToggleGene(
                                              gene,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [_vm._v(_vm._s(gene))]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm.loadedTissueOptions.length
                      ? _c("div", { staticClass: "vks-v2g-settings-block" }, [
                          _c("p", { staticClass: "vks-v2g-settings-label" }, [
                            _vm._v("Tissue"),
                          ]),
                          _c(
                            "ul",
                            {
                              staticClass: "vks-v2g-filter-list",
                              attrs: {
                                role: "group",
                                "aria-label": "Filter tissues",
                              },
                            },
                            _vm._l(_vm.loadedTissueOptions, function (tissue) {
                              return _c(
                                "li",
                                {
                                  key: `filter-tissue-${tissue}`,
                                  staticClass: "vks-v2g-filter-item",
                                },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "vks-v2g-filter-check" },
                                    [
                                      _c("input", {
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked:
                                            _vm.isFilterTissueSelected(tissue),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onToggleFilterTissue(
                                              tissue,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [_vm._v(_vm._s(tissue))]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm.biosampleGroups.length
                      ? _c(
                          "div",
                          { staticClass: "vks-v2g-settings-block" },
                          [
                            _c(
                              "div",
                              { staticClass: "vks-v2g-settings-head" },
                              [
                                _c(
                                  "p",
                                  { staticClass: "vks-v2g-settings-label" },
                                  [_vm._v("Biosamples")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "vks-ui-btn-row vks-v2g-settings-actions",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "vks-ui-btn vks-ui-btn--secondary",
                                        attrs: { type: "button" },
                                        on: { click: _vm.selectAllBiosamples },
                                      },
                                      [_vm._v(" Select all ")]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "vks-ui-btn vks-ui-btn--secondary",
                                        attrs: { type: "button" },
                                        on: {
                                          click: _vm.unselectAllBiosamples,
                                        },
                                      },
                                      [_vm._v(" Unselect all ")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._l(_vm.biosampleGroups, function (group) {
                              return _c(
                                "div",
                                {
                                  key: `biosample-group-${group.tissue}`,
                                  staticClass: "vks-v2g-biosample-group",
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "vks-v2g-biosample-group-title",
                                    },
                                    [_vm._v(_vm._s(group.tissue))]
                                  ),
                                  _c(
                                    "ul",
                                    {
                                      staticClass: "vks-v2g-filter-list",
                                      attrs: {
                                        role: "group",
                                        "aria-label": `Biosamples for ${group.tissue}`,
                                      },
                                    },
                                    _vm._l(
                                      group.biosamples,
                                      function (biosample) {
                                        return _c(
                                          "li",
                                          {
                                            key: _vm.biosampleFilterKey(
                                              group.tissue,
                                              biosample
                                            ),
                                            staticClass: "vks-v2g-filter-item",
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "vks-v2g-filter-check",
                                              },
                                              [
                                                _c("input", {
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    checked:
                                                      _vm.isBiosampleSelected(
                                                        group.tissue,
                                                        biosample
                                                      ),
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.onToggleBiosample(
                                                        group.tissue,
                                                        biosample,
                                                        $event
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c("span", [
                                                  _vm._v(_vm._s(biosample)),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _c(
        "section",
        { staticClass: "vks-drawer-section vks-drawer-section--table" },
        [
          _c(
            "div",
            { staticClass: "vks-v2g-table-section" },
            [
              _c("VariantSifterV2gTable", {
                attrs: { rows: _vm.tableRows, utils: _vm.utils },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }